import { register } from "../src/custom_elements";

// TODO: define props where needed
const props = {};

register(props);
